var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0C15.672 0 0 15.6759 0 35.0159C0 54.3519 15.672 70.0281 35 70.0281C54.332 70.0281 70 54.3519 70 35.0159C70 15.6759 54.332 0 35 0ZM35 6C50.992 6 64 19.0159 64 35.0159C64 51.0119 50.992 64.0281 35 64.0281C19.011 64.0281 6 51.0119 6 35.0159C6 19.0159 19.011 6 35 6Z",
    fill: "#303634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.578 26.0081C27.578 28.2391 25.7689 30.0469 23.5389 30.0469C21.3079 30.0469 19.5039 28.2391 19.5039 26.0081C19.5039 23.7781 21.3079 21.969 23.5389 21.969C25.7689 21.969 27.578 23.7781 27.578 26.0081Z",
    fill: "#303634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0388 26.0081C39.0388 28.2391 37.2298 30.0469 35.0038 30.0469C32.7728 30.0469 30.9648 28.2391 30.9648 26.0081C30.9648 23.7781 32.7728 21.969 35.0038 21.969C37.2298 21.969 39.0388 23.7781 39.0388 26.0081Z",
    fill: "#303634"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4999 26.0081C50.4999 28.2391 48.6948 30.0469 46.4648 30.0469C44.2338 30.0469 42.4248 28.2391 42.4248 26.0081C42.4248 23.7781 44.2338 21.969 46.4648 21.969C48.6948 21.969 50.4999 23.7781 50.4999 26.0081Z",
    fill: "#303634"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.578 36.614C27.578 38.844 25.7689 40.6531 23.5389 40.6531C21.3079 40.6531 19.5039 38.844 19.5039 36.614C19.5039 34.383 21.3079 32.574 23.5389 32.574C25.7689 32.574 27.578 34.383 27.578 36.614Z",
    fill: "#303634"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0388 36.614C39.0388 38.844 37.2298 40.6531 35.0038 40.6531C32.7728 40.6531 30.9648 38.844 30.9648 36.614C30.9648 34.383 32.7728 32.574 35.0038 32.574C37.2298 32.574 39.0388 34.383 39.0388 36.614Z",
    fill: "#303634"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4999 36.614C50.4999 38.844 48.6948 40.6531 46.4648 40.6531C44.2338 40.6531 42.4248 38.844 42.4248 36.614C42.4248 34.383 44.2338 32.574 46.4648 32.574C48.6948 32.574 50.4999 34.383 50.4999 36.614Z",
    fill: "#303634"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 48.696H20.5C19.398 48.696 18.5 47.801 18.5 46.696C18.5 45.59 19.398 44.696 20.5 44.696H49.5C50.605 44.696 51.5 45.59 51.5 46.696C51.5 47.801 50.605 48.696 49.5 48.696Z",
    fill: "#303634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.b7fdf148eef33ea60644a582716edfe9.svg";
export { ForwardRef as ReactComponent };